module.exports = __webpack_public_path__ + "static/media/infoOrange.ffb63272.svg";